import { render, staticRenderFns } from "./RecordDialog.vue?vue&type=template&id=24224828&scoped=true&"
import script from "./RecordDialog.vue?vue&type=script&lang=js&"
export * from "./RecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecordDialog.vue?vue&type=style&index=0&id=24224828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24224828",
  null
  
)

export default component.exports